/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYears200,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYears401,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYears500,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYearsPathParams,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYearsQueryParams,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYearsQueryResponse,
} from "../../types/individualPaymentPaymentHistoryController/GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYears.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYearsPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYearsPathParams>;

export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYearsQueryParamsSchema =
  z
    .object({
      financialPersonId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYearsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYears200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYears200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYears401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYears401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYears500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYears500>;

export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYearsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYears200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidYearsQueryResponse>;
